import { emptyScopeSheet } from './scopeSheetDefaults';
import { DETAILED_SEED_PROJECTS } from './seedScopeSheets';

export const PROJECT_STATUS = {
  DRAFT: 'draft',
  ACTIVE: 'active',
  ON_HOLD: 'on_hold',
  COMPLETED: 'completed',
};

export const PROJECT_STATUS_OPTIONS = [
  { value: PROJECT_STATUS.DRAFT, label: 'Draft' },
  { value: PROJECT_STATUS.ACTIVE, label: 'Active' },
  { value: PROJECT_STATUS.ON_HOLD, label: 'On Hold' },
  { value: PROJECT_STATUS.COMPLETED, label: 'Completed' },
];

export const emptyProjectForm = () => ({
  name: '',
  description: '',
  clientName: '',
  location: '',
  startDate: '',
  endDate: '',
  budget: '',
  status: PROJECT_STATUS.DRAFT,
  scopeDate: '',
  scopeSheet: emptyScopeSheet(),
});

export const getStatusLabel = (status) =>
  PROJECT_STATUS_OPTIONS.find((option) => option.value === status)?.label ||
  status ||
  '—';

export const formatProjectDate = (value) => {
  if (!value) return '—';
  try {
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return String(value);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  } catch {
    return String(value);
  }
};

export const formatBudget = (value) => {
  if (value === '' || value === null || value === undefined) return '—';
  const amount = Number(value);
  if (Number.isNaN(amount)) return String(value);
  return Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0,
  }).format(amount);
};

/** Fully filled sample projects (Mehta 3BHK, Sharma 2BHK, Reddy 4BHK). */
export const SEED_PROJECTS = DETAILED_SEED_PROJECTS;
